module.exports = __webpack_public_path__ + "static/media/zemoga.66a0143a.svg";